export const MAX_ORDER_FLOORS = 15;
